/* Do not modify this line: */
export { coreDetailsTab } from "./CoreDetails";
/* Export additional details components below here.  See CoreDetails.tsx for the required shape of these files */

export { documentsTab } from "./Documents";

export { caseConversationTab } from "@teamprevent/common/messaging/components/CaseConversationTab";
